import { render, staticRenderFns } from "./SalesBySource.vue?vue&type=template&id=20e4e55c&scoped=true"
import script from "./SalesBySource.vue?vue&type=script&lang=js"
export * from "./SalesBySource.vue?vue&type=script&lang=js"
import style0 from "./SalesBySource.vue?vue&type=style&index=0&id=20e4e55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4e55c",
  null
  
)

export default component.exports